/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class ViewAsUserError extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const errorResponse: Object = actionDrawerStore.errorResponse;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:users.messages.view_as_user_failed')}</h3>
            {errorResponse && <p>{actionDrawerStore.errorResponse.message}</p>}
          </div>
          {/* <div className={styles['disable-account-details']}>
                    </div> */}
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
